export default __webpack_public_path__ + "static/media/logo_collapse.1a0fe074.png";